export default __webpack_public_path__ + "static/media/marketplace-white.660c386f.svg";